// ===== Scroll reveal =====
const revealEls = document.querySelectorAll('.reveal');
const io = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      io.unobserve(entry.target);
    }
  });
}, { threshold: 0.15 });
revealEls.forEach(el => io.observe(el));

// ===== Typewriter effect (reusable) =====
// Full text stays in the DOM/visible at all times until the exact moment the
// scroll trigger fires - if the trigger never fires for any reason, the target
// simply remains as normal static text rather than disappearing.
function setupTypewriter(selector, typeSpeed) {
  const el = document.querySelector(selector);
  if (!el) return;
  const fullText = el.textContent;
  const typeIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        typeIo.unobserve(entry.target);
        const naturalHeight = el.offsetHeight;
        el.style.minHeight = naturalHeight + 'px';
        el.textContent = '';
        el.classList.add('typing');
        let charIndex = 0;
        function typeNextChar() {
          charIndex++;
          el.textContent = fullText.slice(0, charIndex);
          if (charIndex < fullText.length) {
            setTimeout(typeNextChar, typeSpeed);
          } else {
            el.classList.remove('typing');
            el.style.minHeight = '';
          }
        }
        typeNextChar();
      }
    });
  }, { threshold: 0.4 });
  typeIo.observe(el);
}
setupTypewriter('.testimonials h2', 55);
setupTypewriter('.coming-soon h2', 55);

// ===== Header shadow / sticky bar on scroll =====
const stickyBar = document.getElementById('stickyBar');
const heroEl = document.querySelector('.hero');
window.addEventListener('scroll', () => {
  if (!heroEl || !stickyBar) return;
  const heroBottom = heroEl.getBoundingClientRect().bottom;
  stickyBar.classList.toggle('show', heroBottom < 0);
});

// ===== Animated stat counters =====
const statNums = document.querySelectorAll('.stat-num');
const statIo = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    const target = parseFloat(el.dataset.target);
    const suffix = el.dataset.suffix || '';
    const isDecimal = target % 1 !== 0;
    let start = 0;
    const duration = 1400;
    const startTime = performance.now();
    function tick(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = start + (target - start) * eased;
      el.textContent = (isDecimal ? value.toFixed(1) : Math.round(value)) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    statIo.unobserve(el);
  });
}, { threshold: 0.5 });
statNums.forEach(el => statIo.observe(el));

// ===== FAQ accordion =====
document.querySelectorAll('.faq-item').forEach(item => {
  const q = item.querySelector('.faq-q');
  const a = item.querySelector('.faq-a');
  q.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(other => {
      other.classList.remove('open');
      other.querySelector('.faq-a').style.maxHeight = null;
    });
    if (!isOpen) {
      item.classList.add('open');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});

// ===== One-time bundle add-to-cart (AJAX, one tap per card) =====
// Each bundle is its own Shopify variant with the discount baked into the price,
// so a card's button adds that exact variant via /cart/add.js — no page jump, a
// green tick to confirm, and a "View cart" bar. Checkout stays 100% on Shopify.
const upsellModal = document.getElementById('upsellModal');
const cartAddedBar = document.getElementById('cartAddedBar');
document.querySelectorAll('.price-add').forEach(btn => {
  btn.addEventListener('click', async () => {
    if (btn.classList.contains('added')) return;
    const variantId = btn.dataset.variantId;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      btn.classList.add('added');
      btn.textContent = '✓ Added';
      btn.disabled = false;
      if (cartAddedBar) cartAddedBar.hidden = false;
    } catch (err) {
      btn.textContent = original;
      btn.disabled = false;
    }
  });
});

// ===== Welcome discount modal =====
const welcomeModal = document.getElementById('welcomeModal');
const modalClose = document.getElementById('modalClose');
const modalForm = document.getElementById('modalForm');
let welcomeShown = sessionStorage.getItem('ss_welcome_shown');

if (!welcomeShown) {
  setTimeout(() => {
    welcomeModal.classList.add('show');
    sessionStorage.setItem('ss_welcome_shown', '1');
  }, 15000);
}
modalClose.addEventListener('click', () => welcomeModal.classList.remove('show'));
modalForm.addEventListener('submit', () => {
  setTimeout(() => {
    modalForm.innerHTML = '<p style="font-weight:700;color:#8f6a35;">Your code: <strong>SECRET15</strong> — 15% off orders $80+ AUD</p>';
  }, 900);
});

// Exit intent
let exitShown = false;
document.addEventListener('mouseleave', (e) => {
  if (e.clientY < 10 && !exitShown && !welcomeModal.classList.contains('show') && !sessionStorage.getItem('ss_welcome_shown')) {
    welcomeModal.classList.add('show');
    exitShown = true;
    sessionStorage.setItem('ss_welcome_shown', '1');
  }
});

// ===== Future product notify modal =====
const notifyModal = document.getElementById('notifyModal');
const notifyClose = document.getElementById('notifyClose');
const notifyForm = document.getElementById('notifyForm');
const notifyProductName = document.getElementById('notifyProductName');
const notifyTag = document.getElementById('notifyTag');

document.querySelectorAll('.notify-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const product = btn.dataset.product;
    notifyProductName.textContent = 'Be the first to know about ' + product;
    notifyTag.value = 'future-product-waitlist, ' + product.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    notifyModal.classList.add('show');
  });
});
notifyClose.addEventListener('click', () => notifyModal.classList.remove('show'));
notifyForm.addEventListener('submit', () => {
  setTimeout(() => {
    notifyForm.innerHTML = '<p style="font-weight:700;color:#8f6a35;">You\'re on the list — we\'ll email you the moment it launches.</p>';
  }, 900);
});

// Close modals on overlay click
[welcomeModal, upsellModal, notifyModal].forEach(modal => {
  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.classList.remove('show');
  });
});
